
(function () {
    'use strict';
    var controllerId = 'cambioPassword';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$filter', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', '$translate', cambioPassword]);

    function cambioPassword($rootScope, common, bDialog, $routeParams, $filter, $uibModal, datacontext, sectionMenu, filterFilter, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        var vm = this;

        vm.save = account_save;
        vm.record = account_get();

        function account_get() {
            datacontext.account_get().then(function (data) {
                return vm.record = data;
            });
        }

        function account_save() {
            datacontext.account_changePassword(vm.record).then(function (result) {
                console.dir(result);
                if (result.status == 200) {
                    vm.record.pwdOld = '';
                    vm.record.pwdNew = '';
                    vm.record.pwdConfirm = '';
                    $('#changePassword').modal('hide');
                    logSuccess($translate.instant('PasswordModificata'));
                } else {
                    logError(result.data.Message);
                }
            });
        }

        $('#changePassword').on('hidden.bs.modal', function (e) {
            $(this)
                .find("input,textarea,select")
                .val('')
                .end()
                .find("input[type=checkbox], input[type=radio]")
                .prop("checked", "")
                .end();

            vm.record = account_get();
        });

   }
})();
